<template>
    <div class="w-full">
        <div class="bg-grey-light text-grey-darkest py-2 px-3 justify-between">
            <span>Milestones</span>
        </div>
        <div v-if="projectMilestones.length > 0"
            v-for="item in projectMilestones"
            class="px-3 flex flex-wrap flex-md-nowrap md:items-baseline md:justify-between text-grey-darkest border-b-1 py-3 hover:bg-grey-lighter cursor-default">
            <div class="flex flex-wrap flex-md-nowrap">
                <span class="mr-2 w-full md:w-auto">{{ item.marked_date }} {{ (item.marked_date_time && item.marked_time) ? markedTime(item.marked_date_time) : ''}}</span>
                <span class="w-full md:w-auto">{{ item.type }}</span>
            </div>
            <div v-if="item.completed_at" class="text-xs mt-2 w-full mt-md-0 md:w-auto">
                <span>({{ item.completed_at }} {{ (item.marked_date_time && item.marked_time) ? markedTime(item.marked_date_time) : ''}})</span>
                <span>Completed</span>
            </div>
        </div>
        <div v-if="projectMilestones.length === 0">
            <div class="text-grey-darkest text-sm">
                Your project does not currently have any milestones.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['project-milestones'],
    methods: {
        markedTime(markedTime){
            return moment.utc(markedTime).local().format('hh:mm A')
        }
    }
}
</script>
